<div class="dropdown">

  <div class="dropdown-trigger" (click)="toggle()" (keydown)="onTriggerKeydown($event)" tabindex="0" role="combobox"
    aria-haspopup="listbox" [attr.aria-expanded]="isOpen" aria-controls="combobox">
    <span class="placeholder" [class.selected]="selectedOption">
      {{ selectedOption?.name || placeholder }}
    </span>

    <span class="arrow" [class.open]="isOpen"><img class="arrow-icon" src="assets/icons/chevron-down-outline.svg"
        alt="Seleccionar" /></span>
  </div>

  <div class="dropdown-panel" *ngIf="isOpen" role="listbox">
    <div class="dropdown-scroll">

      <div class="dropdown-option" *ngFor="let option of options; let i = index" role="option"
        [attr.aria-selected]="i === activeIndex" [class.active]="i === activeIndex"
        (click)="select(option)" (keydown.enter)="select(option); activeIndex = i"
        (keydown.arrowdown)="activeIndex = (i + 1) % options.length">
        {{ option.name }}
      </div>

    </div>
  </div>

</div>